<template>
  <div class="container">
    <div class="green-line"></div>

    <div class="navbar-container">
      <div class="part-left liste flex-row-space-evenly">

        <div class="only-mobile hamburger" @click="menuToggle" :class="[{'active':open}]"><div></div><div class="removable"></div><div></div></div>

        <div class="element flex-row-space-evenly" @click="changeTo('accueil')">
          <div class="puce"></div>
          <div class="texte">Accueil</div>
        </div>

        <div class="element flex-row-space-evenly">
          <div class="puce active"></div>
          <div class="texte">La société</div>
          <ul>
            <li @click="changeTo('societe')"><div>Description</div></li>
            <li @click="changeTo('societe-ambition')"><div>Ambition</div></li>
            <li @click="changeTo('societe-philosophie')"><div>Philosophie et Valeurs</div></li>
          </ul>
        </div>

        <div class="element flex-row-space-evenly">
          <div class="puce"></div>
          <div class="texte">Domaines d'activité</div>
          <ul>
            <li @click="changeTo('domaine')"><div>Télécommunications</div></li>
            <li @click="changeTo('domaine-transport')"><div>Transports</div></li>
            <li @click="changeTo('domaine-cfcf')"><div>Courant fort / Courant faible</div></li>
            <li @click="changeTo('domaine-securite')"><div>Sécurité incendie</div></li>
          </ul>
        </div>

      </div>

      <div class="part-center">
        <div class="section-top">
          <div class="image">
          <img src="../../img/navbar/logo_fond_transparent.svg" alt="" @click="changeTo('accueil')">
          </div>
        </div>
        <div class="section-bottom">
          <img src="../../img/navbar/texte_cyberdine_conseil_blanc.svg" class="only-pc" alt="">
          <transition>
            <img src="../../img/navbar/texte_cyberdine_conseil_blanc.svg" class="only-mobile" v-if="!open" alt="">
            <img src="../../img/navbar/texte_cyberdine_conseil_noir.svg" class="only-mobile" v-if="open" alt="">
          </transition>
        </div>
      </div>

      <div class="part-right liste flex-row-space-evenly">

        <div class="element flex-row-space-evenly">
          <div class="puce"></div>
          <div class="texte">Services</div>
          <ul>
            <li @click="changeTo('assistance')"><div>Assistance technique</div></li>
            <li @click="changeTo('centre-service')"><div>Centre de service</div></li>
          </ul>
        </div>

        <div class="element flex-row-space-evenly" @click="changeTo('accueil', 'confiance')">
          <div class="puce"></div>
          <div class="texte">Ils nous font confiance</div>
        </div>

        <div class="element flex-row-space-evenly" @click="changeTo('contact')">
          <div class="puce"></div>
          <div class="texte">Contact</div>
        </div>

      </div>
    </div>

  </div>
</template>

<script>
    import {menuBus} from "../../main";

    export default {
        props: ['open'],
        methods: {
            menuToggle() {
                this.$emit('toggleMenu');
            },
            changeTo(pageName, id) {
                menuBus.$emit('changePage', pageName, id);
            }
        }
    }
</script>

<style scoped>
  .container {
    top: 0;
    right: 0;
    width: 100%;
    display: flex;
    flex-direction: column;
  }

  .green-line {
    width: 100%;
    height: 3px;
    background-color: #b7e17e;
  }

  .navbar-container {
    width: 100%;
    height: 200px;
    display: flex;
  }

  .liste {
    width: calc(50% - 115px);
    height: 150px;
    background: rgba(22, 33, 57, 0.6);
  }
  .part-center {
    width: 230px;
    height: 100%;
  }
  .part-center .section-top {
    height: 150px;
    width: 100%;
    position: relative;
    cursor: pointer;
  }
  .part-center .section-bottom {
    height: 50px;
    width: 100%;
    position: relative;
  }
  .only-mobile {
    display: none;
  }

  .part-center .section-top .image {
    height: 100%;
    width: 100%;
    background-size: cover;
    background-image: url("../../img/navbar/logo_fond_transparent.svg");
  }
  .part-center .section-bottom img {
    height: 100%;
    max-width: 90vw;
    transform: translateX(-50%);
    position: absolute;
  }

  .part-left, .part-right {
    background-color: rgba(255, 255, 255, 0);
  }

  .liste .element {
    height: 100%;
    cursor: pointer;
    position: relative;
  }
  .liste .element .texte {
    color: white;
    font-weight: bold;
    font-size: 20px;
  }
  .liste .element .puce {
    border-radius: 50%;
    height: 7px;
    width: 7px;
    background: #9fa8bd;
    margin-right: 10px;
    opacity: 0;
  }

  .element:hover .puce {
    opacity: 1 !important;
  }

  .puce.active {
    opacity: 1 !important;
  }

  .element:hover ul {
    display: block;
  }
  .element ul {
    display: none;
    position: absolute;
    top: 150px;
    left: 0;
    background-color: white;
    border-top: 2px solid #9fa8bd;
    margin: 0;
    width: 240px;
    box-shadow: 0px 5px 5px rgba(101, 101, 101, 0.3);
  }
  .part-left .element ul {
    right: 0;
    left: initial;
  }

  li * {
    color: #9fa8bd;
  }
  li {
    height: 70px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-top: 1px solid #9fa8bd;
    margin: 0;
    font-size: 18px;
  }

  .contact-container {
    height: 50px;
    padding-left: 100px;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    background-color: rgba(22, 33, 57, 0.9);
  }
  .contact-container p {
    color: white;
    margin: 0;
  }
  .contact-container img {
    height: 60%;
    margin: 0 20px;
  }
  .contact-container .horizontal-line {
    height: 70%;
    width: 2px;
    background-color: #9fa8bd;
    opacity: 0.5;
    margin-left: 20px;
  }

  .hamburger {
    height: 30px;
    width: 40px;
    margin-left: 40px;

    cursor: pointer;

    position: relative;
  }
  .hamburger div {
    width: 100%;
    height: 5px;
    background-color: black;
    left: 0;
    position: absolute;

    transition: all 0.3s;
  }
  .hamburger .removable {
    top: 50%;
    transform: translateY(-50%);
  }
  .hamburger div:first-child {
    top: 0;
  }
  .hamburger div:last-child {
    bottom: 0;
  }
  .hamburger.active .removable {
    opacity: 0;
  }
  .hamburger.active div:first-child {
    transform: rotate(45deg);
  }
  .hamburger.active div:last-child {
    transform: rotate(-45deg);
  }
  .hamburger.active div {
    top: 50%;
    transform: translateY(-50%);
  }

  /* Tablet et Mobile */
  @media (max-width: 1100px) {
    .navbar-container {
      height: 150px;
    }
    .green-line {
      display: none;
    }
    .liste {
      background-color: white;
    }
    .liste > * {
      display: none;
    }
    .part-center .section-top .image {
      background-image: url("../../img/navbar/logo_fond_blanc.svg");
    }

    .navbar-container > *, .part-center .section-top {
      height: 100px;
    }
    .navbar-container .liste {
      width: calc(50% - 72px)!important;
    }
    .part-center {
      width: 158px;
    }

    .only-mobile {
      display: initial;
    }
    .only-pc {
      display: none;
    }
    .part-left {
      justify-content: flex-start;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/societe/Navbar.vue